import React from 'react'
import AppSafeBack from 'contexts/AppSafeBack'

const useAppSafeBack = () => React.useContext(AppSafeBack)

export default useAppSafeBack
